<template>
  <div v-if="!loading" class="table-footer text-muted small px-2 py-1">
    {{ displayedCount }} Zeilen dargestellt, {{ selectedCount }} Zeilen ausgewählt.
  </div>
</template>

<script>
export default {
  name: 'TableFooter',
  props: {
    displayedCount: {
      type: Number,
      required: true
    },
    selectedCount: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.table-footer {
  flex: 0 0 auto;
  background: #fff;
  border-top: 1px solid #dee2e6;
}
</style>
